import { createAction } from 'redux-act'
import { replace, push } from 'react-router-redux'
import queryString from 'query-string'
import API from 'api'

import { receive as receiveEvent } from './events'

export const update = createAction('reservation/update')
export const clear = createAction('reservation/clear')

export const request = createAction('reservation/request')
export const receive = createAction('reservation/receive')
export const receiveGet = createAction('reservation/receiveGet')

export const updateReservationData = (data) => (dispatch) => {
  dispatch(update(data))
}

export const updateReservationAndQuery = (data) => (dispatch, getState) => {
  dispatch(update(data))

  const { reservation } = getState()
  const query = queryString.parse(window.location.search)
  Object.assign(query, {
    lang: reservation.data.language,
    guests: reservation.data.guests,
    date: reservation.data.start,
    type: reservation.type,
    coupon_code: reservation.data.coupon_code,
  })

  const url = `${window.location.pathname}?${queryString.stringify(query)}${window.location.hash}`
  dispatch(replace(url))
}

export const clearReservation = () => (dispatch) => {
  dispatch(clear())
}

export const create = (id, data) => (dispatch) => {
  dispatch(request({ id, data }))

  return API.reservation(id, data)
    .then(response => {
      dispatch(receive({ id, response }))
      let url = window.location.pathname
      if (!/reservation/.test(url)) {
        url = `${window.location.pathname}/reservation`
      }
      dispatch(push(`${url}${window.location.search}`))
      return Promise.resolve(response)
    })
}

export const fetch = (id, phone, email) => (dispatch) => {
  dispatch(request({ id, phone, email }))

  return API.getReservation(id, phone, email)
    .then(response => dispatch(receive({ id, response })))
}

export const fetchUuid = (uuid) => (dispatch) => {
  dispatch(request({ uuid }))

  return API.getReservationUuid(uuid)
    .then(response => {
      const { reservation, event } = response
      dispatch(update(reservation))
      dispatch(receiveEvent({
        id: event._id,
        locale: reservation.data.language,
        event,
      }))
    })
}

export const finalize = (uuid, data) => (dispatch) => {
  dispatch(request({ uuid, data }))

  return API.finalizeReservation(uuid, data)
    .then(response => {
      dispatch(receive({ uuid, response }))
      return Promise.resolve(response)
    })
}

export const remove = (id, phone, email) => (dispatch) => {
  dispatch(request({ id, phone, email }))

  return API.removeReservation(id, phone, email)
    .then(response => dispatch(receive({ id, response })))
}
